import * as Yup from "yup";

export const otpValidationSchema = Yup.object().shape({
  otp: Yup.string()
    .required("OTP kodu zorunludur")
    .matches(/^\d{6}$/, "OTP 6 haneli bir sayı olmalıdır"),
});
